import React from "react";
import * as styles from "./Card.module.css";
import Button from "../Button";
import Icon from "../Icon";
import CopyBlock from "../CopyBlock";

const Card = (props) => {
  const { icon, headline, copy, cta, copyBlock, style, backgroundColor } =
    props;
  return (
    <div
      className={`${styles.card} ${styles[style]} ${styles[backgroundColor]}`}
      // data-aos="zoom-in-up"
    >
      {icon && <Icon props={icon} />}
      {headline && <h5>{headline}</h5>}
      {copy && <p>{copy}</p>}
      {copyBlock && <CopyBlock props={copyBlock} />}
      {cta && (
        <div>
          <Button
            // isLink={!cta.styleAsButton}
            destination={cta.to}
            opensInNewWindow={cta.opensInNewWindow}
            styleAsButton={cta.styleAsButton}
          >
            {cta.title}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Card;
